import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { CustomerService } from '@proximus/ng-common';
import { OnDestroyHookDirective } from '../shared/hooks';
import { isB2B2ECustomer } from '@dch/products-business-logic';

@Injectable()
export class AuB2B2EOnlyGuard
  extends OnDestroyHookDirective
  implements CanActivate
{
  constructor(private customerService: CustomerService) {
    super();
  }

  canActivate(): Observable<boolean> {
    return new Observable((observer) => {
      this.customerService.getCustomerAccount().subscribe((value) => {
        observer.next(
          (value.getSelectedCustomer() && value.getSelectedCustomer().payer) ||
            !!isB2B2ECustomer(value),
        );
        observer.complete();
      });
    });
  }
}
